<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><rect x="2" y="2" width="20" height="5.5" rx="1.15"/><rect x="2" y="9.25" width="20" height="5.5" rx="1.15"/><rect x="2" y="16.5" width="20" height="5.5" rx="1.15"/></svg>